// extracted by mini-css-extract-plugin
export default {"container":"SinglePost_container__fZUA-","refresh":"SinglePost_refresh__hXpZo","list":"SinglePost_list__e3kbh"};